import Typography from "@mui/material/Typography";
import { LocationSubcategorySelector } from "./LocationSubcategorySelector";

const NetworkLocationFormAgencies = ({ onChange }) => {
  const handleInputChanged = (event, value) => {
    if (onChange && typeof onChange === "function") {
      onChange(event, value);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ mt: 4 }}
      >
        Orts-spezifische Angaben (Agenturen)
      </Typography>
      <LocationSubcategorySelector
        name="location_subcategory"
        idFilter={["226", "227"]}
        onChange={handleInputChanged}
      />
    </>
  );
};

export default NetworkLocationFormAgencies;
